import { AfterContentInit, Component, inject, Input, signal, WritableSignal } from '@angular/core';
import { EventBasic } from '../../../data-services/models/events/event-basic.model';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../data-services/auth.service';
import { AdminEventMenuComponent } from '../../../core/admin-event-menu/feature/admin-event-menu.component';
import { AdminEventWizardComponent } from '../../../admin/events/manage/admin-event-wizard/feature/admin-event-wizard.component';


@Component({
  selector: 'app-event-headline',
  imports: [RouterModule, CommonModule,AdminEventMenuComponent,AdminEventWizardComponent],
  templateUrl: '../ui/headline.component.html',
  styleUrl: '../ui/headline.component.css'
})
export class HeadlineComponent implements AfterContentInit{
  private readonly _authService = inject(AuthService);
  private readonly _route = inject(ActivatedRoute);
  @Input() event?: EventBasic;
  adminMenu: boolean = false;
  wizard:WritableSignal<boolean> = signal(this._route.snapshot.queryParams["show_wizard"] === 'true')

  ngAfterContentInit(): void {
    this.adminMenu = this._authService.isEventAdmin(this.event)
  }
}
